export const LightCyan = 'hsl(193, 38%, 86%)'
export const NeonGreen = 'hsl(150, 100%, 66%)'
export const GrayishBlue = 'hsl(217, 19%, 38%)'
export const DarkGrayishBlue = 'hsl(217, 19%, 24%)'
export const DarkBlue = 'hsl(218, 23%, 16%)'

export const fontFamily = 'Manrope'